import React from "react";
import { Link } from "gatsby";

const ServicesStyle4 = () => {
	return (
		<>
			<div className="services-area ptb-100 dotted-bg">
				<div className="container">
					<div className="row justify-content-center">
						<div className="col-lg-4 col-md-6 col-sm-6">
							<div className="single-service-item">
								<div className="icon">
									<i className="flaticon-presentation"></i>
								</div>
								<h4>
									<Link to="/services/content/business-strategy">
										Business Strategy
									</Link>
								</h4>
								<p>
									Lorem ipsum dolor sit amet consectetur.
									Rutru pretium pulvinar ut nec. Ac consequat
									blandit gravida turpis a risus pharetra
									amet.
								</p>
								<Link
									to="/services/content/business-strategy"
									className="link-btn"
								>
									View More{" "}
									<i className="flaticon-right-up"></i>
								</Link>
							</div>
						</div>

						<div className="col-lg-4 col-md-6 col-sm-6">
							<div className="single-service-item">
								<div className="icon">
									<i className="flaticon-web-programming"></i>
								</div>
								<h4>
									<Link to="/services/content/business-strategy">
										Web Development
									</Link>
								</h4>
								<p>
									Lorem ipsum dolor sit amet consectetur.
									Rutru pretium pulvinar ut nec. Ac consequat
									blandit gravida turpis a risus pharetra
									amet.
								</p>
								<Link
									to="/services/content/business-strategy"
									className="link-btn"
								>
									View More{" "}
									<i className="flaticon-right-up"></i>
								</Link>
							</div>
						</div>

						<div className="col-lg-4 col-md-6 col-sm-6">
							<div className="single-service-item">
								<div className="icon">
									<i className="flaticon-content-management"></i>
								</div>
								<h4>
									<Link to="/services/content/business-strategy">
										Digital Marketing
									</Link>
								</h4>
								<p>
									Lorem ipsum dolor sit amet consectetur.
									Rutru pretium pulvinar ut nec. Ac consequat
									blandit gravida turpis a risus pharetra
									amet.
								</p>
								<Link
									to="/services/content/business-strategy"
									className="link-btn"
								>
									View More{" "}
									<i className="flaticon-right-up"></i>
								</Link>
							</div>
						</div>

						<div className="col-lg-4 col-md-6 col-sm-6">
							<div className="single-service-item">
								<div className="icon">
									<i className="flaticon-coding"></i>
								</div>
								<h4>
									<Link to="/services/content/business-strategy">
										App Development
									</Link>
								</h4>
								<p>
									Lorem ipsum dolor sit amet consectetur.
									Rutru pretium pulvinar ut nec. Ac consequat
									blandit gravida turpis a risus pharetra
									amet.
								</p>
								<Link
									to="/services/content/business-strategy"
									className="link-btn"
								>
									View More{" "}
									<i className="flaticon-right-up"></i>
								</Link>
							</div>
						</div>

						<div className="col-lg-4 col-md-6 col-sm-6">
							<div className="single-service-item">
								<div className="icon">
									<i className="flaticon-curve"></i>
								</div>
								<h4>
									<Link to="/services/content/business-strategy">
										Graphics Design
									</Link>
								</h4>
								<p>
									Lorem ipsum dolor sit amet consectetur.
									Rutru pretium pulvinar ut nec. Ac consequat
									blandit gravida turpis a risus pharetra
									amet.
								</p>
								<Link
									to="/services/content/business-strategy"
									className="link-btn"
								>
									View More{" "}
									<i className="flaticon-right-up"></i>
								</Link>
							</div>
						</div>

						<div className="col-lg-4 col-md-6 col-sm-6">
							<div className="single-service-item">
								<div className="icon">
									<i className="flaticon-data"></i>
								</div>
								<h4>
									<Link to="/services/content/business-strategy">
										Data Analysis
									</Link>
								</h4>
								<p>
									Lorem ipsum dolor sit amet consectetur.
									Rutru pretium pulvinar ut nec. Ac consequat
									blandit gravida turpis a risus pharetra
									amet.
								</p>
								<Link
									to="/services/content/business-strategy"
									className="link-btn"
								>
									View More{" "}
									<i className="flaticon-right-up"></i>
								</Link>
							</div>
						</div>

						<div className="col-lg-4 col-md-6 col-sm-6">
							<div className="single-service-item">
								<div className="icon">
									<i className="flaticon-box"></i>
								</div>
								<h4>
									<Link to="/services/content/business-strategy">
										Product Engineering
									</Link>
								</h4>
								<p>
									Lorem ipsum dolor sit amet consectetur.
									Rutru pretium pulvinar ut nec. Ac consequat
									blandit gravida turpis a risus pharetra
									amet.
								</p>
								<Link
									to="/services/content/business-strategy"
									className="link-btn"
								>
									View More{" "}
									<i className="flaticon-right-up"></i>
								</Link>
							</div>
						</div>

						<div className="col-lg-4 col-md-6 col-sm-6">
							<div className="single-service-item">
								<div className="icon">
									<i className="flaticon-ux-design"></i>
								</div>
								<h4>
									<Link to="/services/content/business-strategy">
										UX/UI Design
									</Link>
								</h4>
								<p>
									Lorem ipsum dolor sit amet consectetur.
									Rutru pretium pulvinar ut nec. Ac consequat
									blandit gravida turpis a risus pharetra
									amet.
								</p>
								<Link
									to="/services/content/business-strategy"
									className="link-btn"
								>
									View More{" "}
									<i className="flaticon-right-up"></i>
								</Link>
							</div>
						</div>

						<div className="col-lg-4 col-md-6 col-sm-6">
							<div className="single-service-item">
								<div className="icon">
									<i className="flaticon-data-analysis"></i>
								</div>
								<h4>
									<Link to="/services/content/business-strategy">
										Big Data &amp; Analytics
									</Link>
								</h4>
								<p>
									Lorem ipsum dolor sit amet consectetur.
									Rutru pretium pulvinar ut nec. Ac consequat
									blandit gravida turpis a risus pharetra
									amet.
								</p>
								<Link
									to="/services/content/business-strategy"
									className="link-btn"
								>
									View More{" "}
									<i className="flaticon-right-up"></i>
								</Link>
							</div>
						</div>
					</div>

					<nav className="pagination-area">
						<ul className="pagination">
							<li className="page-item disabled">
								<a className="page-link" href="/">
									<i className="flaticon-chevron-1"></i>
								</a>
							</li>
							<li className="page-item">
								<a className="page-link active" href="/">
									1
								</a>
							</li>
							<li className="page-item">
								<a className="page-link" href="/">
									2
								</a>
							</li>
							<li className="page-item">
								<a className="page-link" href="/">
									3
								</a>
							</li>
							<li className="page-item">
								<a className="page-link" href="/">
									<i className="flaticon-chevron"></i>
								</a>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</>
	);
};

export default ServicesStyle4;
